import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminReportsComponent } from './components/admin/admin-reports/admin-reports.component';
import { AdminFederationsComponent } from './components/admin/admin-federations/admin-federations.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgOptimizedImage, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { GoogleMapsModule } from '@angular/google-maps';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormSignInComponent } from './auth/form-sign-in/form-sign-in.component';
import { ProfessionalSpaceComponent } from './auth/professional-space/professional-space.component';
import { RegisterRsComponent } from './auth/register-rs/register-rs.component';
import { SignInAdminComponent } from './auth/sign-in-admin/sign-in-admin.component';
import { SignInUserComponent } from './auth/sign-in-user/sign-in-user.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { AdminClubDetailsComponent } from './components/admin/admin-club-details/admin-club-details.component';
import { ContactAddressComponent } from './components/admin/admin-club-details/contact-address/contact-address.component';
import { DiscountComponent } from './components/admin/admin-club-details/discount/discount.component';
import { InfosBookingComponent } from './components/admin/admin-club-details/infos-booking/infos-booking.component';
import { PirorityOfferComponent } from './components/admin/admin-club-details/pirority-offer/pirority-offer.component';
import { PracticePlaceComponent } from './components/admin/admin-club-details/practice-place/practice-place.component';
import { TableBookingProgressComponent } from './components/admin/admin-club-details/table-booking-progress/table-booking-progress.component';
import { TableOfferInprogressComponent } from './components/admin/admin-club-details/table-offer-inprogress/table-offer-inprogress.component';
import { TableOffersClubComponent } from './components/admin/admin-club-details/table-offers-club/table-offers-club.component';
import { UpdateBookingFormComponent } from './components/admin/admin-club-details/update-booking-form/update-booking-form.component';
import { AdminClubsComponent } from './components/admin/admin-clubs/admin-clubs.component';
import { AdminCounterNewBookingComponent } from './components/admin/admin-counter/admin-counter-new-booking/admin-counter-new-booking.component';
import { AdminCounterComponent } from './components/admin/admin-counter/admin-counter.component';
import { TableSearchComponent } from './components/admin/admin-counter/table-search/table-search.component';
import { AdminDiscountAdminComponent } from './components/admin/admin-discount/admin-discount-admin/admin-discount-admin.component';
import { AdminDiscountClubComponent } from './components/admin/admin-discount/admin-discount-club/admin-discount-club.component';
import { AdminDiscountComponent } from './components/admin/admin-discount/admin-discount.component';
import { AdminFilterTableComponent } from './components/admin/admin-filter-table/admin-filter-table.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { AdminOfferPriorityByClubComponent } from './components/admin/admin-offer-priority/admin-offer-priority-by-club/admin-offer-priority-by-club.component';
import { AdminOfferPrioritySoloComponent } from './components/admin/admin-offer-priority/admin-offer-priority-solo/admin-offer-priority-solo.component';
import { AdminOfferPriorityComponent } from './components/admin/admin-offer-priority/admin-offer-priority.component';
import { OfferPreviewDragDropComponent } from './components/admin/admin-offer-priority/offer-preview-drag-drop/offer-preview-drag-drop.component';
import { AdminOfferAddComponent } from './components/admin/admin-offer/admin-offer-add/admin-offer-add.component';
import { ActiveOrDeactivePricingComponent } from './components/admin/admin-offer/admin-offer-pricing/active-or-deactive-pricing/active-or-deactive-pricing.component';
import { AdminOfferPricingComponent } from './components/admin/admin-offer/admin-offer-pricing/admin-offer-pricing.component';
import { AdminOfferTableComponent } from './components/admin/admin-offer/admin-offer-table/admin-offer-table.component';
import { AdminOfferComponent } from './components/admin/admin-offer/admin-offer.component';
import { AdminPaymentsComponent } from './components/admin/admin-payments/admin-payments.component';
import { PaymentsTableComponent } from './components/admin/admin-payments/payments-table/payments-table.component';
import { AdminPlanningComponent } from './components/admin/admin-planning/admin-planning.component';
import { AdminPracticePlaceComponent } from './components/admin/admin-practice-place/admin-practice-place.component';
import { TablePracticeClubSoloComponent } from './components/admin/admin-practice-place/table-practice-club-solo/table-practice-club-solo.component';
import { AdminPreviewOfferComponent } from './components/admin/admin-preview-offer/admin-preview-offer.component';
import { AdminResourceClubComponent } from './components/admin/admin-resource/admin-resource-club/admin-resource-club.component';
import { AdminResourceComponent } from './components/admin/admin-resource/admin-resource.component';
import { AdminStructureAddComponent } from './components/admin/admin-structure-add/admin-structure-add.component';
import { AdminStructureDetailsUpdateComponent } from './components/admin/admin-structure-details-update/admin-structure-details-update.component';
import { AdminStructureDetailsComponent } from './components/admin/admin-structure-details/admin-structure-details.component';
import { AdminStructureComponent } from './components/admin/admin-structure/admin-structure.component';
import { AdminTagsComponent } from './components/admin/admin-tags/admin-tags.component';
import { ChangeColorTagComponent } from './components/admin/admin-tags/change-color-tag/change-color-tag.component';
import { ColorsTableComponent } from './components/admin/admin-tags/colors-table/colors-table.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminModule } from './components/admin/admin.module';
import { PopUpFilterComponent } from './components/admin/pop-up-filter/pop-up-filter.component';
import { OpendialogAddClubComponent } from './components/dialog/open-dialog-add-club/opendialog-add-club.component';
import { OpenDialogAddEditDiscountComponent } from './components/dialog/open-dialog-add-edit-discount/open-dialog-add-edit-discount.component';
import { OpenDialogAddEditPracticePlaceComponent } from './components/dialog/open-dialog-add-edit-practice-place/open-dialog-add-edit-practice-place.component';
import { OpenDialogAddEditResourceComponent } from './components/dialog/open-dialog-add-edit-resource/open-dialog-add-edit-resource.component';
import { OpendialogAddEditTraineeComponent } from './components/dialog/open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';
import { OpenDialogAddEditUserComponent } from './components/dialog/open-dialog-add-edit-user/open-dialog-add-edit-user.component';
import { OpenDialogAddOfferCounterComponent } from './components/dialog/open-dialog-add-offer-counter/open-dialog-add-offer-counter.component';
import { OpenDialogAddTagComponent } from './components/dialog/open-dialog-add-tag/open-dialog-add-tag.component';
import { OpenDialogChoiceClubAdminComponent } from './components/dialog/open-dialog-choice-club-admin/open-dialog-choice-club-admin.component';
import { OpenDialogConfirmBookedComponent } from './components/dialog/open-dialog-confirm-booked/open-dialog-confirm-booked.component';
import { SystempyOfferComponent } from './components/dialog/open-dialog-confirm-booked/systempy-offer/systempy-offer.component';
import { OpenDialogConfirmUpdateBookingComponent } from './components/dialog/open-dialog-confirm-update-booking/open-dialog-confirm-update-booking.component';
import { FormTraineesMobileComponent } from './components/dialog/open-dialog-customize-my-session/form-trainees-mobile/form-trainees-mobile.component';
import { FormTraineesComponent } from './components/dialog/open-dialog-customize-my-session/form-trainees/form-trainees.component';
import { OpendialogCustomizeMySessionComponent } from './components/dialog/open-dialog-customize-my-session/opendialog-customize-my-session.component';
import { OpenDialogDeleteElementComponent } from './components/dialog/open-dialog-delete-element/open-dialog-delete-element.component';
import { OpenDialogDuplicateOfferComponent } from './components/dialog/open-dialog-duplicate-offer/open-dialog-duplicate-offer.component';
import { OpenDialogGoToOfferSessionComponent } from './components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { OpenDialogInConstructionComponent } from './components/dialog/open-dialog-in-construction/open-dialog-in-construction.component';
import { OpendialogLoginComponent } from './components/dialog/open-dialog-login/opendialog-login.component';
import { OpendialogOfferDetailsComponent } from './components/dialog/open-dialog-offer-details/opendialog-offer-details.component';
import { OpenDialogPaymentRefundComponent } from './components/dialog/open-dialog-payment-refund/open-dialog-payment-refund.component';
import { OpenDialogSearchMobileComponent } from './components/dialog/open-dialog-search-mobile/open-dialog-search-mobile.component';
import { OpendialogShowListingComponent } from './components/dialog/open-dialog-show-listing/opendialog-show-listing.component';
import { CustomizeMyOfferFormAllInputComponent } from './components/dialog/opendialog-customize-my-orders/customize-my-offer-form-all-input/customize-my-offer-form-all-input.component';
import { CustomizeMyOfferFormComponent } from './components/dialog/opendialog-customize-my-orders/customize-my-offer-form/customize-my-offer-form.component';
import { CustomizeMyOfferGenericFormComponent } from './components/dialog/opendialog-customize-my-orders/customize-my-offer-generic-form/customize-my-offer-generic-form.component';
import { OpendialogCustomizeMyOrdersComponent } from './components/dialog/opendialog-customize-my-orders/opendialog-customize-my-orders.component';
import { ErrorComponent } from './components/error/error.component';
import { HeaderHomeComponent } from './components/home/header-home/header-home.component';
import { HomeContentComponent } from './components/home/home-content/home-content.component';
import { HomeComponent } from './components/home/home.component';
import { OfferDetailsComponent } from './components/home/offer-details/offer-details.component';
import { OfferHomeComponent } from './components/home/offer-home/offer-home.component';
import { IframeClubComponent } from './components/iframe-club/iframe-club.component';
import { ImageOfferComponent } from './components/image-offer/image-offer.component';
import { MatAccordionTreeComponent } from './components/mat-accordion-tree/mat-accordion-tree.component';
import { MyPersonalInformationComponent } from './components/my-personal-information/my-personal-information.component';
import { ManageQuantityComponent } from './components/my-shopping-bag/manage-quantity/manage-quantity.component';
import { MyShoppingBagComponent } from './components/my-shopping-bag/my-shopping-bag.component';
import { MyTraineesComponent } from './components/my-trainees/my-trainees.component';
import { TraineeOverviewComponent } from './components/my-trainees/trainee-overview/trainee-overview.component';
import { MyWishComponent } from './components/my-wish/my-wish.component';
import { NavComponent } from './components/nav/nav.component';
import { PopUpShoppingBasketComponent } from './components/nav/pop-up-shopping-basket/pop-up-shopping-basket.component';
import { PopUpSignInComponent } from './components/nav/pop-up-sign-in/pop-up-sign-in.component';
import { SessionBookedHistoryComponent } from './components/session-booked-history/session-booked-history.component';
import { SessionBookedOverviewClubComponent } from './components/session-booked-history/session-booked-overview-club/session-booked-overview-club.component';
import { SessionBookedOverviewSessionComponent } from './components/session-booked-history/session-booked-overview-session/session-booked-overview-session.component';
import { SessionBookedOverviewTraineeComponent } from './components/session-booked-history/session-booked-overview-trainee/session-booked-overview-trainee.component';
import { SessionsInfosComponent } from './components/session-booked-history/sessions-infos/sessions-infos.component';
import { ValidationAnimationComponent } from './components/validation-animation/validation-animation.component';
import { appInitializerProviders } from './shared/apiInitializerProviders';
import { ApiMissingTranslationHandler } from './shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from './shared/apiTranslationLoader';
import { ChangeColorThemeDirective } from './shared/directives/change-color-theme.directive';
import { DragDropFileOfferDirective } from './shared/directives/drag-drop-file-offer.directive';
import { InputDateDirective } from './shared/directives/input-date.directive';
import { NumbersOnlyDirective } from './shared/directives/numbers-only.directive';
import { httpInterceptorProviders } from './shared/http-interceptors';
import { SharedModule } from './shared/shared.module';
import { AdminUsedRessourceComponent } from './components/admin/admin-used-ressource/admin-used-ressource.component';
import { OpenDialogLegalNoticesComponent } from './components/dialog/open-dialog-legal-notices/open-dialog-legal-notices.component';
import { AdminModificationsComponent } from './components/admin/admin-modifications/admin-modifications.component';
import { MaintenancePageComponent } from './components/maintenance-page/maintenance-page.component';
import { OpenDialogAddEditParameterComponent } from './components/dialog/open-dialog-add-edit-parameter/open-dialog-add-edit-parameter.component';
import { OpenDialogChooseImageFromClubComponent } from './components/dialog/open-dialog-choose-image-from-club/open-dialog-choose-image-from-club.component';
import { AdminParametersComponent } from './components/admin/admin-parameters/admin-parameters.component';
import { AdminParametersTableComponent } from './components/admin/admin-parameters/admin-parameters-table/admin-parameters-table.component';
import { AutocompleteComponent } from './shared/components/autocomplete/autocomplete.component';
import { AdminSessionsComponent } from './components/admin/admin-sessions/admin-sessions.component';
import { OpenDialogConfirmComponent } from './components/dialog/open-dialog-confirm/open-dialog-confirm.component';
import { RatingComponent } from './components/rating/rating.component';
import { OpenDialogRatingsComponent } from './components/dialog/open-dialog-ratings/open-dialog-ratings.component';
import { OpenDialogAddEditFederationComponent } from './components/dialog/open-dialog-add-edit-federation/open-dialog-add-edit-federation.component';
import { AdminLicencesComponent } from './components/admin/admin-federations/admin-licences/admin-licences.component';
import { OpenDialogAddEditLicenceComponent } from './components/dialog/open-dialog-add-edit-licence/open-dialog-add-edit-licence.component';
import { AdminHelpComponent } from './components/admin/admin-help/admin-help.component';
import { OpenDialogHelpComponent } from './components/dialog/open-dialog-help/open-dialog-help.component';
import { OpenDialogAddEditHelpComponent } from './components/dialog/open-dialog-add-edit-help/open-dialog-add-edit-help.component';
import { AdminSubVideoHelpComponent } from './components/admin/admin-help/admin-sub-video-help/admin-sub-video-help.component';
import { OpenDialogCommentBasketComponent } from './components/dialog/open-dialog-comment-basket/open-dialog-comment-basket.component';
import { OpenDialogTextComponent } from './components/dialog/open-dialog-text/open-dialog-text.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FacebookLoginProvider, GoogleInitOptions, GoogleLoginProvider, GoogleSigninButtonModule, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { OpenDialogImportImageComponent } from './components/dialog/open-dialog-import-image/open-dialog-import-image.component';
import { AdminOffersComponent } from './components/admin/admin-offers/admin-offers.component';
import { AdminOffersTableComponent } from './components/admin/admin-offers/admin-offers-table/admin-offers-table.component';
import { AdminOfferEditComponent } from './components/admin/admin-offers/admin-offer-edit/admin-offer-edit.component';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { AdminOfferEditDescriptionComponent } from './components/admin/admin-offers/admin-offer-edit/admin-offer-edit-description/admin-offer-edit-description.component';
import { AdminOfferEditPricingComponent } from './components/admin/admin-offers/admin-offer-edit/admin-offer-edit-pricing/admin-offer-edit-pricing.component';
import { AdminOfferSessionComponent } from './components/admin/admin-offers/admin-offer-session/admin-offer-session.component';
import { SessionFormComponent } from './components/admin/admin-offers/admin-offer-session/session-form/session-form.component';
import { SessionTableComponent } from './components/admin/admin-offers/admin-offer-session/session-table/session-table.component';
import { AdminOfferFileComponent } from './components/admin/admin-offers/admin-offer-file/admin-offer-file.component';
import { IntersectionObserverDirective } from './shared/directives/intersection-observer.directive';
import { ExternalLinkFormComponent } from './components/admin/admin-offers/admin-offer-file/external-link-form/external-link-form.component';
import { AdminUsersComponent } from './components/admin/admin-users/admin-users.component';
import { OpenDialogAdminUserComponent } from './components/dialog/open-dialog-admin-user/open-dialog-admin-user.component';
import { AdminAnnouncesComponent } from './components/admin/admin-announces/admin-announces.component';
import { OpenDialogAdminAnnounceComponent } from './components/dialog/open-dialog-admin-announce/open-dialog-admin-announce.component';
import { HeaderImageDetailsComponent } from './components/home/header-image-details/header-image-details.component';
import { AdminFormsComponent } from './components/admin/admin-forms/admin-forms.component';
import { OpenDialogAdminFormComponent } from './components/dialog/open-dialog-admin-form/open-dialog-admin-form.component';
import { SubscriptionFormComponent } from './components/home/subscription-form/subscription-form.component';
import { AdminSubscriptionsComponent } from './components/admin/admin-subscriptions/admin-subscriptions.component';
import { AdminSubscriptionFormComponent } from './components/admin/admin-subscription-form/admin-subscription-form.component';


registerLocaleData(localeFr, 'fr');

export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey);
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

const googleLoginOptions: GoogleInitOptions = { oneTapEnabled: false };

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ErrorComponent,
    NavComponent,
    HeaderHomeComponent,
    OfferHomeComponent,
    PopUpSignInComponent,
    SignInAdminComponent,
    SignInUserComponent,
    AdminHomeComponent,
    FormSignInComponent,
    PopUpShoppingBasketComponent,
    AdminOfferComponent,
    AdminOffersComponent,
    AdminOfferTableComponent,
    AdminOfferAddComponent,
    MyShoppingBagComponent,
    HomeContentComponent,
    MyWishComponent,
    MatAccordionTreeComponent,
    OpendialogLoginComponent,
    ValidationAnimationComponent,
    OfferDetailsComponent,
    OpendialogOfferDetailsComponent,
    AdminClubsComponent,
    AdminClubDetailsComponent,
    OpendialogAddClubComponent,
    AdminStructureComponent,
    AdminStructureDetailsComponent,
    AdminStructureDetailsUpdateComponent,
    AdminStructureAddComponent,
    OpendialogCustomizeMyOrdersComponent,
    CustomizeMyOfferFormComponent,
    CustomizeMyOfferGenericFormComponent,
    SignUpComponent,
    RegisterRsComponent,
    OpenDialogConfirmBookedComponent,
    AdminComponent,
    TableOffersClubComponent,
    InfosBookingComponent,
    UpdateBookingFormComponent,
    AdminPreviewOfferComponent,
    AdminFilterTableComponent,
    PopUpFilterComponent,
    CustomizeMyOfferFormAllInputComponent,
    OpenDialogDuplicateOfferComponent,
    AdminPracticePlaceComponent,
    TablePracticeClubSoloComponent,
    OpendialogShowListingComponent,
    AdminOfferPriorityComponent,
    OfferPreviewDragDropComponent,
    AdminOfferPrioritySoloComponent,
    AdminOfferPriorityByClubComponent,
    AdminOfferPricingComponent,
    ManageQuantityComponent,
    NumbersOnlyDirective,
    IntersectionObserverDirective,
    InputDateDirective,
    ChangeColorThemeDirective,
    DragDropFileOfferDirective,
    ActiveOrDeactivePricingComponent,
    AdminDiscountComponent,
    OpenDialogAddEditDiscountComponent,
    AdminDiscountAdminComponent,
    AdminDiscountClubComponent,
    AdminOfferSessionComponent,
    AdminResourceComponent,
    AdminResourceClubComponent,
    AdminCounterComponent,
    AdminCounterNewBookingComponent,
    AdminPlanningComponent,
    AdminOfferFileComponent,
    AdminTagsComponent,
    OpenDialogAddOfferCounterComponent,
    OpenDialogAddEditResourceComponent,
    OpenDialogGoToOfferSessionComponent,
    OpenDialogChoiceClubAdminComponent,
    OpenDialogConfirmUpdateBookingComponent,
    SessionFormComponent,
    SessionTableComponent,
    ContactAddressComponent,
    DiscountComponent,
    PracticePlaceComponent,
    PirorityOfferComponent,
    OpendialogCustomizeMySessionComponent,
    OpendialogAddEditTraineeComponent,
    FormTraineesComponent,
    FormTraineesMobileComponent,
    SessionBookedHistoryComponent,
    SessionsInfosComponent,
    MyTraineesComponent,
    OpenDialogSearchMobileComponent,
    OpenDialogAddEditPracticePlaceComponent,
    SessionBookedOverviewTraineeComponent,
    SessionBookedOverviewSessionComponent,
    SessionBookedOverviewClubComponent,
    TraineeOverviewComponent,
    IframeClubComponent,
    OpenDialogInConstructionComponent,
    OpenDialogPaymentRefundComponent,
    ChangeColorTagComponent,
    OpenDialogAddTagComponent,
    ColorsTableComponent,
    TableOfferInprogressComponent,
    TableBookingProgressComponent,
    ImageOfferComponent,
    SystempyOfferComponent,
    TableSearchComponent,
    AdminPaymentsComponent,
    PaymentsTableComponent,
    MyPersonalInformationComponent,
    OpenDialogAddEditUserComponent,
    AdminUsedRessourceComponent,
    ProfessionalSpaceComponent,
    OpenDialogLegalNoticesComponent,
    AdminModificationsComponent,
    MaintenancePageComponent,
    OpenDialogAddEditParameterComponent,
    OpenDialogChooseImageFromClubComponent,
    AdminParametersComponent,
    AdminParametersTableComponent,
    AutocompleteComponent,
    AdminSessionsComponent,
    OpenDialogConfirmComponent,
    RatingComponent,
    OpenDialogRatingsComponent,
    AdminFederationsComponent,
    OpenDialogAddEditFederationComponent,
    AdminLicencesComponent,
    OpenDialogAddEditLicenceComponent,
    AdminHelpComponent,
    OpenDialogHelpComponent,
    AdminReportsComponent,
    OpenDialogAddEditHelpComponent,
    AdminSubVideoHelpComponent,
    OpenDialogCommentBasketComponent,
    OpenDialogTextComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    OpenDialogImportImageComponent,
    AdminOffersTableComponent,
    AdminOfferEditComponent,
    AdminOfferEditDescriptionComponent,
    AdminOfferEditPricingComponent,
    ExternalLinkFormComponent,
    AdminUsersComponent,
    OpenDialogAdminUserComponent,
    AdminAnnouncesComponent,
    OpenDialogAdminAnnounceComponent,
    HeaderImageDetailsComponent,
    AdminFormsComponent,
    OpenDialogAdminFormComponent,
    SubscriptionFormComponent,
    AdminSubscriptionsComponent,
    AdminSubscriptionFormComponent,
    OpenDialogDeleteElementComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonicModule,
    ScrollingModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
    SocialLoginModule,
    GoogleSigninButtonModule,
    GooglePlaceModule,
    SimplebarAngularModule,
    GoogleMapsModule,
    AngularEditorModule,
    NgOptimizedImage,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetterFactory,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token']
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler
      }
    })
  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.idGoogle, googleLoginOptions)
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.idFacebook),
          },
        ],
        onError: (err) => {
          console.error('err', err)
        }
      } as SocialAuthServiceConfig
    },
    { provide: LOCALE_ID, useValue: 'fr' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 0,
        hideDelay: 0,
        touchendHideDelay: 1500,
        position: 'below',
        disableTooltipInteractivity: true
      },
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
